import React from 'react';
import { Link } from 'react-router-dom';
import { Sprout, Trophy, Sparkles, Users, Shield, Award } from 'lucide-react';
const PROGRAMS = [{
  icon: Sprout,
  age: 'Ages 3–5',
  title: 'Mini Troopers',
  desc: 'Preschool-friendly Taekwondo that builds listening, balance and confidence.',
  href: '/mini-troopers'
}, {
  icon: Trophy,
  age: 'Ages 6+',
  title: 'Kids Taekwondo',
  desc: 'Real Taekwondo training, positive coaching, belt progression.',
  href: '/karate-kids-classes.html'
}, {
  icon: Sparkles,
  age: 'Adults',
  title: 'Adult Classes',
  desc: 'Beginner-friendly adult Taekwondo fitness, skill, confidence.',
  href: '/karate-adult-classes'
}, {
  icon: Users,
  age: 'All Ages',
  title: 'Family Classes',
  desc: 'Parents and kids train side by side on the same mat.',
  href: '/FamilyKarateClasses.html'
}, {
  icon: Shield,
  age: 'Adults',
  title: 'Self-Defense',
  desc: 'Practical self-defense skills and awareness for everyday life.',
  href: '/self-defense-classes-in-farmington-hills-michigan'
}, {
  icon: Award,
  age: 'Kids & Teens',
  title: 'Competition Team',
  desc: 'For students ready to compete in Olympic-style sparring and forms.',
  href: '/taekwondo-competitions-in-farmington-hills-michigan'
}];
export function FreeTrialPrograms() {
  return <section className="py-24 bg-paper border-b border-subtle-gray" data-id="element-1550">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1551">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-1552">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1553">
            Choose the Right Storm Program
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1554">
            Storm has classes and programs for almost every age and goal. Pick
            what fits — or tell us a bit about you and let a coach recommend the
            best starting class.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1555">
          {PROGRAMS.map((p, i) => <Link key={i} to={p.href} className="group bg-off-white border border-subtle-gray rounded-2xl p-6 flex flex-col gap-3 hover:border-storm-red transition-colors" data-id="element-1556">
              <div className="w-12 h-12 bg-storm-red/10 rounded-xl flex items-center justify-center text-storm-red group-hover:bg-storm-red group-hover:text-white transition-colors" data-id="element-1557">
                <p.icon className="w-6 h-6" data-id="element-1558" />
              </div>
              <p className="text-xs uppercase tracking-wide text-gray-warm font-bold" data-id="element-1559">
                {p.age}
              </p>
              <h3 className="text-xl text-ink leading-tight" data-id="element-1560">{p.title}</h3>
              <p className="text-gray-warm text-sm leading-relaxed flex-grow" data-id="element-1561">
                {p.desc}
              </p>
              <span className="text-storm-red font-bold text-sm group-hover:underline" data-id="element-1562">
                Learn more →
              </span>
            </Link>)}
        </div>

        <div className="text-center mt-10" data-id="element-1563">
          <Link to="/Programs.html" className="text-storm-red font-bold hover:underline inline-flex items-center gap-1" data-id="element-1564">
            See All Programs →
          </Link>
        </div>
      </div>
    </section>;
}